<template>
  <div class="filter">
    <div class="filter_form">
      <div class="level bottom">
        <div class="level-left"></div>
        <div class="level-right filter_actions">
          <button
            class="delete_branch"
            @click="$emit('delete-checked')"
            :disabled="!rows.checked.length">
            <i class="mdi mdi-folder-remove-outline"></i> Удалить
          </button>
          <button class="add_branch" @click="$emit('open-modal')">
            <i class="mdi mdi-folder-plus-outline"></i> Добавить группу
          </button>
        </div>
      </div>
      <form class="level" @submit.prevent="$emit('change')">
        <b-field label="Поиск по названию группы:" class="branch_search input_search with_button" type="is-info">
          <b-input placeholder="Поиск групп" v-model="search.name"></b-input>
          <button type="submit">Поиск</button>
        </b-field>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    search: {
      default: () => {},
      type: Object
    },
    rows: {
      default: () => {},
      type: Object
    }
  }
}
</script>
